import { useContext } from "react";
import { Table, TableBody, TableCell, TableHead, TablePagination, TableRow, Typography } from "@mui/material";
import { IoMdCheckbox as CheckIcon, IoMdSquareOutline as SquareIcon } from 'react-icons/io';
import { toolTypologiesContext } from '../ToolTypologiesContext';
import { DeleteIconButton, EditIconButton, NotesIconTooltip } from "components";


let Results = () => {
    let service = useContext(toolTypologiesContext);

    return (
        <>
            {service.recordCount === 0 &&
                <Typography gutterBottom variant="subtitle2">Nessuna tipologia trovata</Typography>
            }
            {service.recordCount > 0 &&
                <>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Nome</TableCell>
                                <TableCell>Necessita Manutenzione</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {service.toolTypologies.map((toolTypology, index) =>
                                <TableRow hover key={index}>
                                    <TableCell>{toolTypology.name}</TableCell>
                                    <TableCell>
                                        {toolTypology.needMaintenance === true ? <CheckIcon></CheckIcon> : <SquareIcon></SquareIcon>}
                                    </TableCell>
                                    <TableCell align="right">
                                        {toolTypology.notes != null && toolTypology.notes !== '' &&
                                            <NotesIconTooltip notes={toolTypology.notes} />
                                        }
                                        <EditIconButton link={`/toolTypology/edit/${toolTypology.toolTypologyId}`} />
                                        <DeleteIconButton onClick={() => service.deleteToolTypology(toolTypology.toolTypologyId)} />
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                    <TablePagination
                        component="div"
                        style={{ padding: 0 }}
                        count={service.recordCount}
                        onPageChange={(e, pageNr) => service.handleChangePage(pageNr)}
                        page={service.search.pageNr}
                        rowsPerPage={service.search.pageSize}
                        rowsPerPageOptions={[service.search.pageSize]}
                        labelDisplayedRows={({ page, count }) =>
                            <>
                                Tipologie totali:&nbsp;{count} &nbsp;&middot;&nbsp;
                                <span>Pagina {page + 1} di {Math.ceil(count / service.search.pageSize)}</span>
                            </>
                        }
                    />
                </>
            }
        </>
    )
}

export default Results;